import { useEffect, useState } from 'react';
import { LAST_UPDATED, UPDATED_JUST_NOW } from '../constants/LtsConstants';

function useRefreshTimer({
  timerInitialValue,
  refreshIntervalInMilliseconds,
  updateTimeThresholdInMinutes,
  callbackOnTimeOut
}) {
  const [autoRefresh, setAutoRefresh] = useState(null);
  const [timeInMinutes, setTimeInMinutes] = useState(timerInitialValue);
  const [timerText, setTimerText] = useState('');
  const [timerDescription, setTimerDescription] = useState('');
  const [thresholdReached, setThresholdReached] = useState(false);
  const [manualRefreshCount, setManualRefreshCount] = useState(0);

  useEffect(() => {
    const autoRefreshNew = setInterval(updateTimerText, refreshIntervalInMilliseconds);
    setAutoRefresh(autoRefreshNew);
    return () => {
      clearInterval(autoRefresh);
    };
  }, []);

  useEffect(() => {
    setTimerText(timeInMinutes === 0 ? UPDATED_JUST_NOW : `${timeInMinutes.toString().padStart(2, '0')} min ago`);
    setTimerDescription(timeInMinutes === 0 ? '' : LAST_UPDATED);
    setThresholdReached(timeInMinutes === updateTimeThresholdInMinutes);
  }, [timeInMinutes]);

  function updateTimerText() {
    if (!thresholdReached) {
      setTimeInMinutes((timeInMinutes) => timeInMinutes + 1);
    }
  }
  function refreshSteps() {
    callbackOnTimeOut();
    if (autoRefresh) {
      clearInterval(autoRefresh);
    }
    setTimeInMinutes(timerInitialValue);
    const autoRefreshNew = setInterval(updateTimerText, refreshIntervalInMilliseconds);
    setAutoRefresh(autoRefreshNew);
  }

  useEffect(() => {
    if (thresholdReached) {
      refreshSteps();
    }
  }, [thresholdReached]);

  useEffect(() => {
    refreshSteps();
  }, [manualRefreshCount]);

  const result = {
    callbackForManualRefresh: () => setManualRefreshCount((prevState) => prevState + 1),
    updateTimeText: timerText,
    updateAgoDescription: timerDescription
  };
  return result;
}

export default useRefreshTimer;
